import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LdapSync } from '../../shared/models/ldap.model';
import { MatIconModule } from '@angular/material/icon';
import { FwPopoverModule, FwIconModule, FwLayoutsModule } from '@flywheel-io/vision';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ldap-indicator',
  standalone: true,
  imports: [
    MatIconModule,
    FwPopoverModule,
    FwIconModule,
    CdkOverlayOrigin,
    FwLayoutsModule,
    CommonModule,
],
  templateUrl: './ldap-indicator.component.html',
  styleUrl: './ldap-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LdapIndicatorComponent {

  ldapStatus = input.required<LdapSync>();
}
